import { render, staticRenderFns } from "./Viewer3D.vue?vue&type=template&id=218c58a0&"
import script from "./Viewer3D.vue?vue&type=script&lang=js&"
export * from "./Viewer3D.vue?vue&type=script&lang=js&"
import style0 from "./Viewer3D.vue?vue&type=style&index=0&id=218c58a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports